export default "__VITE_ASSET__BpUdnsUz__"